import React from 'react'
import Marked from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import PropTypes from 'prop-types'

import { getImageSrc, getImageSrcset } from '../util/getImageUrl'
import './Content.css'

const encodeMarkdownURIs = (source = '') => {
  const markdownLinkRegex =
    /\[(?:\[[^\]]*\]|[^[\]])*\]\([ \t]*<?((?:\([^)]*\)|[^()])*?)>?[ \t]*(['"].*?\6[ \t]*)?\)/g
  return source.replace(markdownLinkRegex, (match, linkURI) => {
    if (!linkURI) return match
    const replaced = match.replace(linkURI, encodeURI(linkURI))
    return replaced
  })
}

const ImageWithSrcset = ({ node, src, alt, ...props }) => {
  const decodedSrc = decodeURI(src)
  return (
    <img
      className="Content--Image"
      {...props}
      src={getImageSrc(decodedSrc)}
      srcSet={getImageSrcset(decodedSrc)}
      alt={alt}
    />
  )
}

const IframeBlock = ({ node, ...props }) => (
  <div className="Content--Iframe">
    <iframe title="Embedded content" {...props} />
  </div>
)

const Content = ({ source, src, className = '' }) => (
  <div className={`Content ${className}`}>
    <Marked
      rehypePlugins={[rehypeRaw]}
      components={{
        img: ImageWithSrcset,
        iframe: IframeBlock,
      }}
    >
      {encodeMarkdownURIs(source || src)}
    </Marked>
  </div>
)

Content.propTypes = {
  source: PropTypes.string,
  src: PropTypes.string,
  className: PropTypes.string,
}

export default Content
